import httpClient from '../utils/axios'
import {
    handleServiceError,
    handleServiceResponse,
} from '../utils/serviceResponseHelper'

const getAllGroups = async serviceId => {
    try {
        const response = await httpClient.get(
            `${window.config.SERVICE_MANAGEMENT_API_URL}/rolePermissionGroups/${serviceId}`
        )
        return handleServiceResponse(response)
    } catch (error) {
        return await handleServiceError(error)
    }
}

const getPermissionGroup = async rolePermissionGroupId => {
    try {
        const response = await httpClient.get(
            `${window.config.SERVICE_MANAGEMENT_API_URL}/rolePermissionGroup/${rolePermissionGroupId}`
        )
        return handleServiceResponse(response)
    } catch (error) {
        return await handleServiceError(error)
    }
}

const createPermissionGroup = async ({
    processEngineServiceId,
    roleId,
    title,
    isEnabled,
}) => {
    const payload = {
        RoleId: roleId,
        Title: title,
        IsEnabled: isEnabled,
    }

    try {
        const response = await httpClient.post(
            `${window.config.SERVICE_MANAGEMENT_API_URL}/rolePermissionGroup/${processEngineServiceId}`,
            payload,
            {
                headers: { 'Content-Type': 'application/json' },
            }
        )
        return handleServiceResponse(response)
    } catch (error) {
        return await handleServiceError(error)
    }
}

const updatePermissionGroup = async ({
    permissionGroupId,
    roleId,
    title,
    isEnabled,
}) => {
    const payload = {
        RoleId: roleId,
        Title: title,
        IsEnabled: isEnabled,
    }

    try {
        const response = await httpClient.put(
            `${window.config.SERVICE_MANAGEMENT_API_URL}/rolePermissionGroup/${permissionGroupId}`,
            payload,
            {
                headers: { 'Content-Type': 'application/json' },
            }
        )
        return handleServiceResponse(response)
    } catch (error) {
        return await handleServiceError(error)
    }
}

const getAllGroupMembers = async userPermissionGroupId => {
    try {
        const response = await httpClient.get(
            `${window.config.SERVICE_MANAGEMENT_API_URL}/rolePermissionGroup/members/${userPermissionGroupId}`
        )
        return handleServiceResponse(response)
    } catch (error) {
        return await handleServiceError(error)
    }
}

const getAllPermissions = async () => {
    try {
        const response = await httpClient.get(
            `${window.config.SERVICE_MANAGEMENT_API_URL}/rolePermissionGroup/rules/`
        )
        return handleServiceResponse(response)
    } catch (error) {
        return await handleServiceError(error)
    }
}

export default {
    getAllGroups,
    getPermissionGroup,
    createPermissionGroup,
    updatePermissionGroup,
    getAllGroupMembers,
    getAllPermissions,
}
